module.exports = __webpack_public_path__ + "img/高通75.746a497f.png";